<div class="container">
  <h1>Gestion des tailles</h1>

  <!-- Formulaire pour ajouter ou mettre à jour une taille -->
  <form (ngSubmit)="saveSize()">
    <div class="input-container">
      <label for="title">Nom de la taille :</label>
      <input type="text" id="title" class="form-control" [(ngModel)]="selectedSize.title" name="title" required />
    </div>

    <button type="submit" class="btn btn-primary">{{ isUpdating ? 'Mettre à jour une taille' : 'Ajouter une taille' }}</button>
  </form>

  <!-- Message d'erreur si besoin -->
  <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

  <!-- Liste des tailles existantes -->
  <div *ngIf="sizes.length > 0" class="size-list">
    <h2>Tailles existantes</h2>
    <ul>
      <li *ngFor="let size of sizes">
        <strong>{{ size.title }}</strong>
        <button (click)="editSize(size)">Modifier</button>
        <button (click)="deleteSize(size.id)">Supprimer</button>
      </li>
    </ul>
  </div>
</div>
